import { contextFactory } from '../../../factories/contextFactory.js';

const [TableContext, useTableContext] = contextFactory();

export { TableContext, useTableContext };
